import { useEffect, useState } from "react";
import { createProductReview, getProductReviewEligibility } from "@/api/customer.api.js";
import IOSToggle from "@/components/IOSToggle.jsx";
import "@/pages/product/product-reviews.css";

export default function ProductReviewForm({ productId, productTitle, onDone, onCancel }) {
    const [grade, setGrade] = useState(0);
    const [comment, setComment] = useState("");
    const [anonymous, setAnonymous] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");
    const [eligible, setEligible] = useState(null);

    useEffect(() => {
        getProductReviewEligibility(productId)
            .then((data) => setEligible(data.data))
            .catch((err) => setError(err.message));
    }, [productId]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (grade < 1 || grade > 5) {
            setError("Veuillez sélectionner une note.");
            return;
        }
        setSubmitting(true);
        setError("");
        try {
            await createProductReview(productId, {
                grade,
                comment: comment.trim() || null,
                anonymous
            });
            onDone?.();
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    if (eligible && !eligible.canReview) {
        return (
            <div className="product-review-form">
                <p className="muted">
                    {eligible.alreadyReviewed
                        ? "Vous avez déjà laissé un avis pour ce produit."
                        : "Vous ne pouvez noter que les produits d'une commande terminée."}
                </p>
                {onCancel && (
                    <button type="button" className="btn btn-secondary btn-inline" onClick={onCancel}>
                        Fermer
                    </button>
                )}
            </div>
        );
    }

    return (
        <form className="product-review-form" onSubmit={handleSubmit}>
            <h3>Laisser un avis{productTitle ? ` — ${productTitle}` : ""}</h3>
            <div>
                <p className="muted" style={{ margin: "0 0 0.5rem" }}>Note (obligatoire)</p>
                <div className="product-review-grade-picker" role="group" aria-label="Note">
                    {[1, 2, 3, 4, 5].map((value) => (
                        <button
                            key={value}
                            type="button"
                            className={grade >= value ? "is-selected" : ""}
                            aria-pressed={grade === value}
                            onClick={() => setGrade(value)}
                        >
                            ★
                        </button>
                    ))}
                </div>
            </div>
            <label className="field">
                Commentaire (optionnel)
                <textarea
                    rows={4}
                    maxLength={2000}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    disabled={submitting}
                />
            </label>
            <IOSToggle
                id="review-anonymous"
                label="Publier anonymement"
                description="Nom et photo masqués sur la fiche produit."
                checked={anonymous}
                disabled={submitting}
                onChange={setAnonymous}
            />
            {error && <p className="error">{error}</p>}
            <div className="profile-form-actions">
                {onCancel && (
                    <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={submitting}>
                        Annuler
                    </button>
                )}
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={submitting || !eligible?.canReview || grade < 1}
                >
                    {submitting ? "Envoi..." : "Publier l'avis"}
                </button>
            </div>
        </form>
    );
}
